import { Follow, FollowWithUser } from '../../domain/models';

// Entity representing the database structure
export interface FollowEntity {
  id: string;
  follower_id: string;
  following_id: string;
  created_at: string;
}

export interface FollowWithUserEntity extends FollowEntity {
  follower_name?: string;
  follower_email?: string;
  follower_avatar_url?: string;
  following_name?: string;
  following_email?: string;
  following_avatar_url?: string;
}

// Mapper: from Entity (DB) to Model (Domain)
export const followEntityToModel = (entity: FollowEntity): Follow => {
  return {
    id: entity.id,
    followerId: entity.follower_id,
    followingId: entity.following_id,
    createdAt: new Date(entity.created_at),
  };
};

export const followWithUserEntityToModel = (entity: FollowWithUserEntity): FollowWithUser => {
  return {
    id: entity.id,
    followerId: entity.follower_id,
    followingId: entity.following_id,
    createdAt: new Date(entity.created_at),
    userName: entity.follower_name || entity.following_name,
    userEmail: entity.follower_email || entity.following_email,
    userAvatarUrl: entity.follower_avatar_url || entity.following_avatar_url,
  };
};

// Mapper: from Model (Domain) to Entity (DB)
export const followModelToEntity = (model: Partial<Follow>): Partial<FollowEntity> => {
  return {
    id: model.id,
    follower_id: model.followerId,
    following_id: model.followingId,
    created_at: model.createdAt?.toISOString(),
  };
};
